export default __webpack_public_path__ + "static/media/location--8.59eb5cca.jpg";